export const CHAT_MAX_FILE_SIZE = 25000000; // 25mb
export const FEED_MAX_IMAGE_SIZE = 100000000; // 100mb
export const CH_FEED_MAX_IMAGE_SIZE = 10000000; // 10mb
export const FEED_MAX_VIDEO_SIZE = 300000000; // 300mb
export const GROUP_CHANNEL_MAX_MEMBER_COUNT = 1990;
export const GROUP_CHANNEL_MODERATOR_ID = "5f3ab17e3751a00d86c50532";
export const POLL_OPTION_MAX_CHAR_LIMIT = 50;
export * from "./config";

export const PROFILE_URL_PREFIX = "https://profile.leap.club/profile-details/";

export const POST_SUBMITTED_FOR_REVIEW_TEXT =
  "your post has been submitted for review. we will let you know as soon as the post gets approved or rejected. to understand more about the community guidelines click on the 'read more' button below";

export const storeUrls = {
  APP_STORE: "itms-apps://apps.apple.com/US/app/id1534682865",
  PLAY_STORE: "https://play.google.com/store/search?q=leap.club&c=apps",
};

export const externalUrls = {
  LEAP_CLUB_WEBSITE: "https://leap.club",
  TERMS_OF_USE: "https://leap.club/terms_of_use",
  LEAP_SUPPORT: "mailto:members@leap.club",
  WHATSAPP_INVITE:
    "https://api.whatsapp.com/send?phone=919966736782&text=i%20would%20like%20to%20refer%20a%20friend%20to%20leap.club%2C%20here%20are%20her%20details%3A%0A%0Afull%20name%3A%0Anumber%3A%0Aemail%3A%0Alinkedin%20profile%3A",
  ABOUT_LEAP:
    "https://leapclub.notion.site/leapclub/the-leap-club-playbook-c974468f29d7400caedf020700b5baf7",
  LEAP_CLUB_BLOG: "https://leapclub.medium.com/",
  POST_GUIDELINES:
    "https://www.notion.so/leap-club-post-like-a-star-61b58ca89de845b7b023340e12f77822",
};

export const storageKeys = {
  USER_COLOR_PREF: "userColorPref",
  USER_ACCESS_TOKEN: "userAccessToken",
  USER_REFRESH_TOKEN: "userRefreshToken",
  USER_PROFILE_IMAGE: "userProfileImage",
  USER_NAME: "userName",
  USER_ID: "userId",
  HAS_VIEWED_REFERRAL_SCREEN: "hasViewedReferralScreen",
};

export const firebaseKeys = {
  LOWEST_ALLOWED_VERSION: "/v3LowestAllowedVersion",
  MAINTENANCE: "/v3Maintenance",
};

export const inboxType = {
  MAIN: "MAIN",
  REQUESTS: "REQUESTS",
};

export const commInitiationLocation = {
  SC_POPUP: "SC_POPUP",
};

export const uploadTypes = {
  FEED_IMAGES: "feedImages",
  FEED_VIDEOS: "feedVideos",
  PROFILE_PICS: "profilePics",
};

export const searchFilterTags = {
  industryTags: [
    "advertising & marketing",
    "design",
    "e-commerce",
    "education, edtech",
    "f&b",
    "fmcg",
    "founders",
    "health & wellness",
    "hospitality",
    "hr, recruitment",
    "internet & tech",
    "law",
    "looking for investors, co-founders, advisors",
    "looking for mentors",
    "media",
    "operations",
    "pr, communications",
    "product & tech",
    "retail",
    "sales & marketing, partnerships",
    "social impact",
    "strategy & consulting",
    "telecom",
    "vc & fin services",
  ],
  skillTags: [
    "strategy",
    "data analytics",
    "sales & business development",
    "brand & marketing",
    "team management",
    "the 0-1 journey/new business",
    "content creation & communication",
    "design",
    "digital marketing",
    "sports/sports management",
    "operations",
    "startups",
    "project management",
    "finance and accounting",
  ],
  workExperienceTags: [
    "0 - 3 years",
    "3 - 6 years",
    "6 - 9 years",
    "9 - 12 years",
    "12 - 15 years",
    "15 - 18 years",
    "18 years and above",
  ],
  cityTags: [
    "delhi ncr",
    "mumbai",
    "bengaluru",
    "hyderabad",
    "pune",
    "chennai",
    "global",
    "other",
  ],
};

export const clubhouseTags = [
  "fun",
  "entrepreneurs",
  "health & wellness",
  "technology",
  "groups",
  "food & drinks",
  "investing & finance",
  "professional",
  "gender",
  "cities",
  "career growth",
  "self-growth",
  "sales & marketing",
];

export const clubhouseVerifiedBadgeExplanatoryPoints = [
  "posts get more visibility on the feed. build your presence and reach out to more members 🔥",
  "early access to leap.club experiences 🔥",
  "apply for unlimited jobs/month 🔥",
  "your profile stands out in front of recruiters 🔥",
];

export const handpickedBadgeExplanatoryPoints = [
  "popular or trending posts based on engagement from other members",
  "posts from active members and cxo’s. these posts are handpicked as usually content from such members gets a lot of engagement",
];

export const prompts = [
  "a life goal of mine",
  "apparently, my life’s soundtrack is",
  "biggest risk i’ve taken",
  "give me travel tips for",
  "most spontaneous thing i’ve done",
  "my most controversial opinion is",
  "never have i ever",
  "two truths and a lie",
  "what i order for the table",
  "superconnect with me for...",
  "i feel empowered when...",
  "a passion project i am working on now is...",
  "i am confused about...",
];

export const coachListingFilters = [
  {
    label: "all",
    value: "all",
  },
  {
    label: "bengaluru",
    value: "bengaluru",
  },
  {
    label: "delhi ncr",
    value: "delhi ncr",
  },
  {
    label: "mumbai",
    value: "mumbai",
  },
  {
    label: "other",
    value: "other",
  },
];

export const coachListingSortOptions = [
  {
    label: "alphabetical",
    value: "alphabetical",
  },
  {
    label: "price: low to high",
    value: "priceAsc",
  },
  {
    label: "price: high to low",
    value: "priceDsc",
  },
];

export const interactionTypes = {
  POST: "post",
  COMMENT: "comment",
  REPLY: "reply",
  LIKE: "like",
  BOOKMARK: "bookmark",
  QUOTE: "quote",
};

export const pages = [
  {
    label: "feed",
    route: "/feed/all",
  },
  {
    label: "connect",
    route: "/superconnections",
  },
  {
    label: "clubs",
    route: "/joined-clubhouses/all",
    // route: "/clubs",
  },
  {
    label: "events",
    route: "/experiences/upcoming",
  },
];

export const settings = [
  {
    id: "visit_profile",
    label: "view profile",
  },
  {
    id: "my_activity",
    label: "my activity",
  },
  {
    id: "invite_friend",
    label: "invite a friend",
  },
  {
    id: "change_password",
    label: "change password",
  },
  {
    id: "share_feedback",
    label: "share feedback",
  },
  {
    id: "share_profile",
    label: "share profile",
  },
  {
    id: "logout",
    label: "logout",
  },
];

export const bannerTypes = {
  PROMOTIONAL: "promotional",
  INVITE: "invite",
  RENEWAL: "renewal",
};

export const upcomingExperiencesCategories = {
  LEARN: "learn",
  NOT_LEARN: "notLearn",
};

export const DEFAULT_CONTENT_SLICING_POS = 300;

export const DEFAULT_CHAT_PARENT_MSG_SLICING_POS = 220;

export const regexPatterns = {
  mentionsRegex: /(@\[.*?\]\(.*?\))/g,
  // urlRegex:
  //   /(https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*))/i,
  urlRegex:
    /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi,
  phoneRegex: /([\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,7})/g,
  emailRegex: /(\S+@\S+\.\S+)/g,
};

export const APP_ROUTES = {
  LOGIN_SCREEN: "loginScreen",
  FEED_SCREEN: "feedScreen",
  CLUBHOUSE_SCREEN: "clubhouseScreen",
  SC_SCREEN: "scScreen",
  EXPERIENCE_SCREEN: "experienceScreen",
  JOB_SCREEN: "jobScreen",
  COACHING_SCREEN: "coachingScreen",
  COACH_DETAIL_SCREEN: "coachDetailScreen",
  COACH_BOOKING_PAYMENT_SCREEN: "coachBookingPaymentScreen",
  FORGOT_PASSWORD_SCREEN: "forgotPasswordScreen",
  RESET_PASSWORD_SCREEN: "resetPasswordScreen",
  UPCOMING_EXPERIENCE_DETAIL_SCREEN: "upcomingExperienceDetailScreen",
  EXPERIENCE_SLOT_QUESTION_SCREEN: "experienceSlotQuestionScreen",
  PROFILE_SCREEN: "profileScreen",
  EDIT_PROFILE_SCREEN: "editProfileScreen",
  EDIT_INTRODUCTION_SCREEN: "editIntroductionScreen",
  EDIT_HERO_SCREEN: "editHeroScreen",
  EDIT_ADMIRED_COMPANIES_SCREEN: "editAdmiredCompaniesScreen",
  EDIT_EDUCATION_SCREEN: "editEducationScreen",
  EDIT_TAGS_AND_INDUSTRIES_SCREEN: "editTagsAndIndustriesScreen",
  EDIT_TOPSKILLS_SCREEN: "editTopSkillsScreen",
  EDIT_HOBBIES_SCREEN: "editHobbiesScreen",
  EDIT_EXPERIENCE_SCREEN: "editExperienceScreen",
  EDIT_PREVIOUS_EXPERIENCE_SCREEN: "editPreviousExperienceScreen",
  EDIT_GOALS_SCREEN: "editGoalsScreen",
  EDIT_FEATURED_LINKS_SCREEN: "editFeaturedLinksScreen",
  EDIT_PROMPT_SCREEN: "editPromptScreen",
  SELECT_PROMPT_SCREEN: "selectPromptScreen",
  MAIN_TABS_SCREEN: "mainTabsScreen",
  BOOKED_SESSIONS_SCREEN: "bookedSessionsScreen",
  INVITE_SCREEN: "inviteScreen",
  NOTIFICATION_SCREEN: "notificationScreen",
  POST_DETAIL_SCREEN: "postDetailScreen",
  CREATE_POST_SCREEN: "createPostScreen",
  SC_SEARCH_SCREEN: "scSearchScreen",
  SC_SEARCH_RESULTS: "scSearchResults",
  MY_SC_SCREEN: "myScScreen",
  MAIN_INBOX_LIST_SCREEN: "mainInboxListScreen",
  REQUEST_INBOX_LIST_SCREEN: "requestInboxListScreen",
  PERSONAL_CHAT_SCREEN: "personalChatScreen",
  CREATE_CLUBHOUSE_SCREEN: "createClubhouseScreen",
  SHARE_FEEDBACK_SCREEN: "shareFeedbackScreen",
  SC_MESSAGE_SCREEN: "scMessageScreen",
  JOIN_CLUBHOUSE_SCREEN: "joinClubhouseScreen",
  CLUBHOUSE_DETAIL_SCREEN: "clubhouseDetailScreen",
  JOINED_CLUBHOUSE_DETAIL_SCREEN: "joinedClubhouseDetailScreen",
  JOIN_REQUESTS_SCREEN: "joinRequestsScreen",
  CLUBHOUSE_CHAT_SCREEN: "clubhouseChatScreen",
  CLUBHOUSE_BANNED_MEMBERS: "clubhouseBannedMembersScreen",
  APP_HOME: "appHomeScreen",
  REPORT_SCREEN: "reportScreen",
  CHANGE_PASSWORD_SCREEN: "changePasswordScreen",
  OTHER_USER_ACTIVITY_SCREEN: "otherUserActivityScreen",
  EXTERNAL_URL: "externalUrl", // don't change this name
  PREVIEW_AND_ADD_MEMBERS_TO_CLUBHOUSE_SCREEN:
    "previewAndAddMembersToClubhouseScreen",
  COURSE_DETAIL_SCREEN: "courseDetailScreen",
  COURSE_INSTRUCTOR_SCREEN: "courseInstructorScreen",
  REFERRAL_SCREEN: "referralScreen",
  CLUBHOUSE_POST_DETAIL_SCREEN: "clubhousePostDetailScreen",
  JOINED_CLUBHOUSE_FEED_SCREEN: "joinedClubhouseFeedScreen",
};

export const APP_TABS = {
  FEED: "feed",
  CLUBHOUSE: "clubhouse",
  SUPERCONNECT: "sc",
  EXPERIENCE: "experiences",
  COACHING: "learn",
};

export const unprotectedRoutes = ["/profile-details/[profileId]"];

export const analyticsConstants = {
  TAB: {
    FEED: "feed_tab",
    EXPERIENCES: "experiences_tab",
    LEARN: "learn_tab",
    NETWORK: "my_network_tab",
    CLUBHOUSE: "clubhouse_tab",
  },
  SCREEN: {
    FEED_SCREEN: "feed_page",
    FEED_CREATE_POST_SCREEN: "create_a_post",
    EXPERIENCE_SCREEN: "experience_page",
    UPCOMING_EXPERIENCE_DETAILS: "experience_detail_page",
    COACHING_SCREEN: "coaching_page",
    COURSE_PAGE: "course_page",
    MASTERCLASS_PAGE: "masterclass_page",
    COACH_PAGE: "coach_page",
    PROFILE_PAGE: "profile_page",
    SEARCH_PAGE: "search_page",
    CH_CREATE_POST: "create_a_post",
    JOIN_CLUBHOUSE: "join_a_clubhouse",
    CLUBHOUSE_PAGE: "clubhouse_page",
    CLUBHOUSE_DETAILS_PAGE: "clubhouse_details",
    SIDE_DRAWER: "side_drawer",
    REFERRAL_SCREEN: "referral_page",
    POST_DETAIL_SCREEN: "post_detail_screen",
    MY_NETWORK_PAGE: "my_network_page",
    SEARCH_FILTERS_PAGE: "search_filter_page",
    SEARCH_RESULTS_PAGE: "search_result_page",
  },
  CATEGORY: {
    CLICK: "click",
    SWIPE: "swipe",
  },
  TYPE: {
    BUTTON: "button",
    ICON: "icon",
    CARD: "card",
    LINK: "link",
    TAB: "tab",
    INPUT: "input",
    CHICLET: "chiclet",
    TOGGLE: "toggle",
  },
};

export const profileUpdateFormDiversityOptions = {
  cityOptions: [
    "delhi ncr",
    "mumbai",
    "bengaluru",
    "hyderabad",
    "pune",
    "chennai",
    "kolkata",
    "singapore",
    "dubai",
  ],
  experienceOptions: [
    "0 - 3 years",
    "3 - 6 years",
    "6 - 9 years",
    "9 - 12 years",
    "12 - 15 years",
    "15 - 18 years",
    "18 years and above",
  ],
  skillsOptions: [
    "engineering services (software/civil/other)",
    "strategy",
    "data analytics",
    "sales & business development",
    "brand & marketing",
    "team management",
    "the 0-1 journey/new business",
    "content creation & communication",
    "design",
    "digital marketing",
    "sports/sports management",
    "operations",
    "startups",
    "project management",
    "finance and accounting",
  ],
  postionOptions: [
    "associate / analyst",
    "manager / sr. manager",
    "director / avp / team lead",
    "vp",
    "svp/ cxo",
    "certified independent professional (CFA, lawyer etc.)",
    "entrepreneur",
    "freelancer",
    "trainer/ educator",
  ],
  salaryRangeOptions: [
    "<10 lakhs",
    "10 - 15 lakhs",
    "15 - 20 lakhs",
    "20 - 30 lakhs",
    "30 - 45 lakhs",
    "45 -  60 lakhs",
    ">60 lakhs",
    "self employed",
    "on a break",
  ],
  memberDirectoryOptions: [
    "advertising & marketing",
    "design",
    "e-commerce",
    "education, edtech",
    "f&b",
    "fmcg",
    "founders",
    "health & wellness",
    "hospitality",
    "hr, recruitment",
    "internet & tech",
    "law",
    "looking for investors, co-founders, advisors",
    "looking for mentors",
    "media",
    "operations",
    "pr, communications",
    "product & tech",
    "retail",
    "sales & marketing, partnerships",
    "social impact",
    "strategy & consulting",
    "telecom",
    "vc & fin services",
  ],
};

const statesList = [
  "Andaman and Nicobar Islands",
  "Andhra Pradesh",
  "Arunachal Pradesh",
  "Assam",
  "Bihar",
  "Chandigarh",
  "Chhattisgarh",
  "Dadra and Nagar Haveli",
  "Daman and Diu",
  "Delhi",
  "Goa",
  "Gujarat",
  "Haryana",
  "Himachal Pradesh",
  "Jammu and Kashmir",
  "Jharkhand",
  "Karnataka",
  "Kerala",
  "Ladakh",
  "Lakshadweep",
  "Madhya Pradesh",
  "Maharashtra",
  "Manipur",
  "Meghalaya",
  "Mizoram",
  "Nagaland",
  "Odisha",
  "Puducherry",
  "Punjab",
  "Rajasthan",
  "Sikkim",
  "Tamil Nadu",
  "Telangana",
  "Tripura",
  "Uttar Pradesh",
  "Uttarakhand",
  "West Bengal",
];
